import { render, staticRenderFns } from "./Henrolment.vue?vue&type=template&id=63092c84&scoped=true&"
import script from "./Henrolment.vue?vue&type=script&lang=js&"
export * from "./Henrolment.vue?vue&type=script&lang=js&"
import style0 from "./Henrolment.vue?vue&type=style&index=0&id=63092c84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63092c84",
  null
  
)

export default component.exports